import React from 'react';
import Form from 'react-bootstrap/Form';
import Styles from './Publish.module.scss';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const IntegrationCard = ({
  integration,
  handleActive,
  handleUpdate,
  handleDelete,
}) => {
  return (
    <div className={Styles.publish_container_new}>
      <div className={Styles.main_channel_container}>
        <div className={Styles.card_channel}>
          <div className={Styles.d_flex_channel_logo_box}>
            <div className={Styles.channel_logo_name}>
              <div className={Styles.channel_logo}>
                <img src={`/Images/${integration.type}.svg`} alt="wordpress" />
              </div>
              <p className={Styles.logo_name}>{integration?.name}</p>
            </div>

            <DropdownButton
              title={<BsThreeDotsVertical color="#182230" />}
              // onClick={handlePropagation}
            >
              {integration.category !== 'social' && (
                <Dropdown.Item onClick={() => handleUpdate(integration)}>
                  <div className={Styles.DropdownItem}>
                    <FiEdit size={14} />
                    <p className={Styles.DropdownItem_Text}>Edit</p>
                  </div>
                </Dropdown.Item>
              )}

              <Dropdown.Item onClick={() => handleDelete(integration)}>
                <div className={Styles.DropdownItem}>
                  <FiTrash2 size={14} />
                  <p className={Styles.DropdownItem_Text}>Delete</p>
                </div>
              </Dropdown.Item>
            </DropdownButton>
          </div>
          <div className={Styles.detail_section}>
            {integration.category === 'social' ? (
              integration?.integration_data?.type === 'page' ? (
                <>
                  <ul className={Styles.detail_list}>
                    <li className={Styles.list_detail_item}>Page's name</li>
                    <li className={Styles.list_name_item}>
                      <small>{integration?.integration_data?.page_name}</small>
                    </li>
                  </ul>
                  <ul className={Styles.detail_list}>
                    <li className={Styles.list_detail_item}>Page's category</li>
                    <li className={Styles.list_name_item}>
                      <small>{integration?.integration_data?.category}</small>
                    </li>
                  </ul>
                </>
              ) : (
                <>
                  <ul className={Styles.detail_list}>
                    <li className={Styles.list_detail_item}>User's name</li>
                    <li className={Styles.list_name_item}>
                      {integration?.integration_data?.first_name}{' '}
                      {integration?.integration_data?.last_name}
                    </li>
                  </ul>
                  <ul className={Styles.detail_list}>
                    <li className={Styles.list_detail_item}>User's email</li>
                    <li className={Styles.list_name_item}>
                      {integration?.integration_data?.email}
                    </li>
                  </ul>
                </>
              )
            ) : (
              <>
                <ul className={Styles.detail_list}>
                  <li className={Styles.list_detail_item}>Integration</li>
                  <li className={Styles.list_name_item}>
                    {integration?.account}
                  </li>
                </ul>
                <ul className={Styles.detail_list}>
                  <li className={Styles.list_detail_item}>Website</li>
                  <li className={Styles.list_name_item}>
                    {integration?.site_identification}
                  </li>
                </ul>
              </>
            )}
          </div>
          <div className={Styles.active_section}>
            <p className={Styles.active_status}>Active:</p>
            <p className={Styles.active_status}>
              <div
                className={`${Styles.cylinderToggle} ${integration.is_active ? Styles.active : ''}`}
                onClick={() => handleActive(integration)}
              >
                <Form>
                  <Form.Check
                    type="switch"
                    className={Styles.cylinderToggle__switch}
                    checked={integration.is_active}
                    onChange={(e) => {
                      handleActive(integration);
                    }}
                  />
                </Form>
              </div>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationCard;
